import { lazy } from "react";

// project imports
import Loadable from "ui-component/Loadable";
import MinimalLayout from "layout/MinimalLayout";
import AprobarNegar from "pages/credito/AprobarNegar";
import SolicitudCredito from "pages/credito/SolicitudCredito";
import Caja from "pages/transaction/Caja";
import AperturaCaja from "pages/transaction/AperturaCaja";
import EstadoCuenta from "pages/transaction/EstadoCuenta";
import Garantes from "pages/credito/Garantes";
import TablaAmortizacion from "pages/credito/TablaAmortizacion";

// login option 3 routing
const AuthLogin3 = Loadable(lazy(() =>
    import("pages/security/login/Login")));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: "/",
    element: <MinimalLayout />,
    children: [
        {
            index: true,
            element: <AuthLogin3 />,
        },
        {
            path: "pages/transaction/AperturaCaja",
            element: <AperturaCaja />,
        },
        {
            path: "pages/transaction/Caja",
            element: <Caja />,
        },
        {
            path: "pages/transaction/EstadoCuenta",
            element: <EstadoCuenta />,
        },
        {
            path: "pages/credito/SolicitudCredito",
            element: <SolicitudCredito />,
        },
        {
            path: "pages/credito/AprobarNegar",
            element: <AprobarNegar />,
        },
        {
            path: "pages/credito/Garantes",
            element: <Garantes />,
        },
        {
            path: "pages/credito/TablaAmortizacion",
            element: <TablaAmortizacion />,
        },
    ],
};

export default AuthenticationRoutes;